import { useWarehouseStore } from '../store/warehouseStore';

export const useCurrentWarehouse = () => {
    const { currentWarehouse } = useWarehouseStore();
    console.log(currentWarehouse)
    return {
        warehouseId: currentWarehouse?.id ? String(currentWarehouse.id) : null,
        warehouse: currentWarehouse
    };
}; 